export * from './gis-boundary-detail-page.component';